/* eslint-disable react-hooks/exhaustive-deps */
import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import { SelectGeneric } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

import { getPositionsByContract } from '../../../../../services/adminContracts';
import PositionLineContainer from '../../../../PositionLineContainer/PositionLineContainer';
import { usePositionLineForm } from '../../../hooks';
import styles from '../WeeklyReportFilters.module.scss';

const PositionLineFilter = forwardRef(({ formData, contratosIds, onChangePositonLine }, ref) => {
  const [positionOptions, setPositionOptions] = useState([]);
  const [errorPositionLine, setErrorPositionLine] = useState('');
  const currentContractsSelected = useMemo(
    () => contratosIds?.map((e) => e.nombre),
    [contratosIds]
  );

  const {
    handlePositionLineChange,
    resetPositionAndLineFields,
    addPositionLine,
    deletePositionLine,
    resetPositionLineChips,
    positionLine,
    linesOptions,
    position,
    line
  } = usePositionLineForm({
    filters: formData,
    currentContractsSelected,
    setErrorPositionLine
  });

  useEffect(() => {
    if (contratosIds?.length) {
      getPositionsByContract(currentContractsSelected).then((data) => {
        setPositionOptions(data);
      });
    }
  }, [contratosIds]);

  useImperativeHandle(ref, () => ({
    resetFiltersOnChanges: (newValue) => {
      setErrorPositionLine('');
      if (newValue) resetPositionAndLineFields();
      if (newValue?.length === 0) resetPositionLineChips();
    },
    positionLine
  }));

  useEffect(() => {
    if (positionLine && onChangePositonLine) {
      onChangePositonLine(positionLine);
    }
  }, [positionLine]);

  return (
    <div className={`mt-4 mx-2 ${styles['filter-container']}`}>
      <Row>
        <Col sm={6}>
          <SelectGeneric
            defaultValueOneOption={false}
            isDisabled={Boolean(!contratosIds?.length)}
            label="Posición"
            name="position"
            onChange={(newValue) => handlePositionLineChange('position', newValue)}
            options={positionOptions}
            placeholder="--"
            showIcon
            value={!contratosIds?.length ? null : position}
            withSelect="100%"
          />
        </Col>
        <Col sm={6}>
          <SelectGeneric
            defaultValueOneOption={false}
            isDisabled={!contratosIds?.length || Boolean(!position)}
            label="Linea"
            name="line"
            onChange={(newValue) => {
              addPositionLine(newValue);
            }}
            options={linesOptions}
            placeholder="--"
            showIcon
            value={!contratosIds?.length ? null : line}
            withSelect="100%"
          />
        </Col>
      </Row>
      <PositionLineContainer
        contractsSelected={currentContractsSelected}
        deletePositionLineVE={deletePositionLine}
        extendedView
        positionLine={positionLine}
      />
      {!!errorPositionLine?.length && (
        <span className={styles['filter-alert']}>{errorPositionLine}</span>
      )}
    </div>
  );
});

PositionLineFilter.propTypes = {
  formData: PropTypes.shape({
    posicionesLineas: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string
      })
    )
  }),
  contratosIds: PropTypes.arrayOf(PropTypes.number),
  onChangePositonLine: PropTypes.func
};

PositionLineFilter.defaultProps = {
  formData: {},
  contratosIds: [],
  onChangePositonLine: () => {}
};

PositionLineFilter.displayName = 'PositionLineFilter';

export default PositionLineFilter;
